export const SET_SEARCH_TEXT = "wishCreateReducer/set_search_text";
export const SET_SURPRISE_WISH = "wishCreateReducer/set_surprise_wish";
export const SET_SUGGESTED = "wishCreateReducer/set_suggested";
export const SET_TIMEOUT = "wishCreateReducer/set_timeout";
export const SET_LOADING_STATUS = "wishCreateReducer/set_loading_status";
export const SET_RECIPIENT = "wishCreateReducer/set_recipient";
export const RESET = "wishCreateReducer/reset";
